<template>
<div class="chapter">
<div class="inner_page">
<p class="para"><a id="piv"></a><span epub:type="pagebreak" id="pageiv" title="iv"><a id="copyright"></a> </span></p>
<p class="para"> </p>
<p class="copy">First published in 2019 by</p>
<p class="copy1">Birlinn Limited</p>
<p class="copy1">West Newington House</p>
<p class="copy1">10 Newington Road</p>
<p class="copy1">Edinburgh</p>
<p class="copy1">EH9 1QS</p>
<p class="copy1"><a href="http://www.birlinn.co.uk" target="_blank">www.birlinn.co.uk</a></p>
<p class="copy">Copyright © James Hunter 2019</p>
<p class="copy"><span class="small">ISBN</span> 978 1 78885 231 9</p>
<p class="copy">The right of James Hunter to be identified as the Author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy">All rights reserved. No part of this publication may be reproduced in any form or by any means without permission from the publisher.</p>
<p class="copy">British Library Cataloguing in Publication Data</p>
<p class="copy">A catalogue record for this book is available from the British Library.</p>
<p class="copy">Typeset by Hewer Text UK Ltd, Edinburgh</p>
<p class="copy1">Printed and bound by Gutenberg Press, Malta</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?79d2b285